


































import Vue from 'vue';
import SidePage from 'common/components/ui/SidePage/index.vue';

export default Vue.extend({
  components: {
    SidePage,
  },
  computed: {
    inputLines(): Array<string> {
      const lines = this.filledValues && this.filledValues.split('\n');
      return lines && lines.map((c: string) => c.trim());
    },
    hasValue(): boolean {
      return this.items && this.items.length > 0;
    },
  },
  props: {
    custom: Object,
    show: Boolean,
    format: String,
    items: Array as () => string[],
  },
  data() {
    return {
      filledValues: null,
      value: ([] as string[]),
    };
  },
  methods: {
    valid(str: string) {
      switch (this.format) {
        case 'number':
          return !isNaN(Number(str));
        default:
          return str.trim().length > 0;
      }
    },
    confirmValues() {
      let hasEmpty = false;
      this.inputLines.forEach(function(v) {
        if (!v || v.trim().length === 0) {
          hasEmpty = true;
        }
      });
      if (hasEmpty) {
        this.$Message.warning('当前存在错误');
      } else {
        this.value = this.inputLines;
        this.updateItems();
      }
    },
    updateItems() {
      this.$emit('update', this.value);
    },
    close() {
      this.$emit('close');
    },
  },
  mounted() {
    this.value = this.items;
    this.filledValues = this.value && this.value.join('\n');
  },
});
